export default __webpack_public_path__ + "static/media/bg.12ec0d12.svg";